import "./Canvas.scss";
import { useRef, useEffect } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import {
  useGLTF,
  useTexture,
  useAnimations,
  AccumulativeShadows,
  RandomizedLight,
  Environment,
} from "@react-three/drei";
import { easing } from "maath";
import { useSnapshot } from "valtio";
import { state, meshParts } from "../store";
import * as THREE from "three";
import CameraControls from "camera-controls";
// import RotationWrapper from "./RotationWrapper";

const model = process.env.PUBLIC_URL + "/assets/ALAM_UVMirrorAnim.glb";
CameraControls.install({ THREE });

export const Canvas1 = ({
  position = [0, 0, 2.5],
  fov = 25,
  scroll,
  isFanRotating,
}) => {
  return (
    <Canvas
      shadows
      camera={{ position, fov }}
      gl={{ preserveDrawingBuffer: true }}
      eventSource={document.getElementById("root")}
      eventPrefix="client"
      className="scene"
    >
      <ambientLight intensity={0.2} />
      <Environment files={'/assets/venice_sunset_1k.hdr'} />
      {/* <CameraRig> */}
      <Backdrop />
      {/* <RotationWrapper scroll={scroll}>
          <AlaM position={[0, 0, 0]} rotation-x={0.4} rotation-y={0.4} />
        </RotationWrapper> */}
      <AlaM scroll={scroll} isFanRotating={isFanRotating} />
      {/* </CameraRig> */}
    </Canvas>
  );
};

function Backdrop() {
  const shadows = useRef();
  useFrame((state, delta) =>
    easing.dampC(
      shadows.current.getMesh().material.color,
      state.color,
      0.25,
      delta
    )
  );
  return (
    <AccumulativeShadows
      ref={shadows}
      temporal
      frames={60}
      alphaTest={0.85}
      scale={10}
      rotation={[0, 0, 0]}
      position={[0, -0.44, 0]}
    >
      <RandomizedLight
        amount={4}
        radius={9}
        intensity={0.55}
        ambient={0.25}
        position={[5, 5, -10]}
      />
      <RandomizedLight
        amount={4}
        radius={5}
        intensity={0.25}
        ambient={0.55}
        position={[0, 5, 0]}
      />
    </AccumulativeShadows>
  );
}

// function CameraRig({ children }) {
//   const group = useRef();
//   const snap = useSnapshot(state);
//   useFrame((state, delta) => {
//     easing.damp3(
//       state.camera.position,
//       [snap.intro ? (0, 0, 0) : 0, 0, 2],
//       0.25,
//       delta
//     );
//     easing.dampE(
//       group.current.rotation,
//       [state.pointer.y / 10, -state.pointer.x / 5, 0],
//       0.25,
//       delta
//     );
//   });
//   return <group ref={group}>{children}</group>;
// }

const AlaM = (props) => {
  const { scroll, isFanRotating } = props;
  const snap = useSnapshot(state);
  const texture = {};
  let c = 0;
  texture[meshParts[c]] = useTexture(
    `${process.env.PUBLIC_URL}/assets/TextureAlaM/${
      snap.texture[meshParts[c++]]
    }`
  );
  texture[meshParts[c]] = useTexture(
    `${process.env.PUBLIC_URL}/assets/TextureAlaM/${
      snap.texture[meshParts[c++]]
    }`
  );
  texture[meshParts[c]] = useTexture(
    `${process.env.PUBLIC_URL}/assets/TextureAlaM/${
      snap.texture[meshParts[c++]]
    }`
  );
  texture[meshParts[c]] = useTexture(
    `${process.env.PUBLIC_URL}/assets/TextureAlaM/${
      snap.texture[meshParts[c++]]
    }`
  );
  texture[meshParts[c]] = useTexture(
    `${process.env.PUBLIC_URL}/assets/TextureAlaM/${
      snap.texture[meshParts[c++]]
    }`
  );
  texture[meshParts[c]] = useTexture(
    `${process.env.PUBLIC_URL}/assets/TextureAlaM/${
      snap.texture[meshParts[c++]]
    }`
  );
  texture[meshParts[c]] = useTexture(
    `${process.env.PUBLIC_URL}/assets/TextureAlaM/${
      snap.texture[meshParts[c++]]
    }`
  );
  texture[meshParts[c]] = useTexture(
    `${process.env.PUBLIC_URL}/assets/TextureAlaM/${
      snap.texture[meshParts[c++]]
    }`
  );
  texture[meshParts[c]] = useTexture(
    `${process.env.PUBLIC_URL}/assets/TextureAlaM/${
      snap.texture[meshParts[c++]]
    }`
  );
  texture[meshParts[c]] = useTexture(
    `${process.env.PUBLIC_URL}/assets/TextureAlaM/${
      snap.texture[meshParts[c++]]
    }`
  );
  texture[meshParts[c]] = useTexture(
    `${process.env.PUBLIC_URL}/assets/TextureAlaM/${
      snap.texture[meshParts[c++]]
    }`
  );
  // texture[meshParts[c]] = useTexture(`/assets/TextureAlaM/${snap.texture[meshParts[c++]]}`);

  const group = useRef();
  const { nodes, animations } = useGLTF(model);
  const { actions } = useAnimations(animations, group);

  useEffect(() => {
    if (actions) {
      actions["OtherAction.002"].play().paused = true;
    }
  }, [actions]);
  useEffect(() => {
    const fanAnimation = actions["FanAction.002"].play();
    fanAnimation.paused = !isFanRotating;
    fanAnimation.loop = true;
    fanAnimation.timeScale = 10;
  }, [actions, isFanRotating]);

  useFrame((state) => {
    actions["OtherAction.002"].time =
      actions["OtherAction.002"].getClip().duration * scroll.current;
  });

  return (
    <>
      <group ref={group} name="Group">
        <mesh
          name="Sopra"
          castShadow
          geometry={nodes.Sopra.geometry}
          // {...props}
          dispose={null}
        >
          <meshStandardMaterial
            map={texture["top"]}
            roughnessMap={
              snap.texture.topRoughness !== "Normal_Base.jpg"
                ? texture["topRoughness"]
                : null
            }
            metalnessMap={
              snap.texture.topMetallic !== "Normal_Base.jpg"
                ? texture["topMetallic"]
                : null
            }
            normalMap={
              snap.texture.topNormal !== "Normal_Base.jpg"
                ? texture["topNormal"]
                : null
            }
          ></meshStandardMaterial>
        </mesh>
        <mesh
          name="Sotto"
          castShadow
          geometry={nodes.Sotto.geometry}
          // {...props}
          dispose={null}
        >
          <meshStandardMaterial
            map={texture["bot"]}
            roughnessMap={
              snap.texture.botRoughness !== "Normal_Base.jpg"
                ? texture["botRoughness"]
                : null
            }
            metalnessMap={
              snap.texture.botMetallic !== "Normal_Base.jpg"
                ? texture["botMetallic"]
                : null
            }
            normalMap={
              snap.texture.botNormal !== "Normal_Base.jpg"
                ? texture["botNormal"]
                : null
            }
          ></meshStandardMaterial>
        </mesh>
        <mesh
          name="Other"
          castShadow
          geometry={nodes.Other.geometry}
          // {...props}
          dispose={null}
        >
          <meshStandardMaterial
            map={texture["other"]}
            roughnessMap={
              snap.texture.otherRoughness !== "Normal_Base.jpg"
                ? texture["topRoughness"]
                : null
            }
            metalnessMap={
              snap.texture.otherMetallic !== "Normal_Base.jpg"
                ? texture["otherMetallic"]
                : null
            }
            normalMap={
              snap.texture.otherNormal !== "Normal_Base.jpg"
                ? texture["otherNormal"]
                : null
            }
          ></meshStandardMaterial>
        </mesh>
        <mesh
          name="Fan"
          castShadow
          geometry={nodes.Fan.geometry}
          // {...props}
          // position={[-0.204493, -0.361315, -0.263647]}
          position={[-0.204493, -0.263647, 0.361315]}
          dispose={null}
        >
          <meshStandardMaterial
            map={texture["other"]}
            roughnessMap={
              snap.texture.otherRoughness !== "Normal_Base.jpg"
                ? texture["topRoughness"]
                : null
            }
            metalnessMap={
              snap.texture.otherMetallic !== "Normal_Base.jpg"
                ? texture["otherMetallic"]
                : null
            }
            normalMap={
              snap.texture.otherNormal !== "Normal_Base.jpg"
                ? texture["otherNormal"]
                : null
            }
          ></meshStandardMaterial>
        </mesh>
      </group>
    </>
  );
};

useGLTF.preload(model);
// materialsAlaM.map().forEach(useTexture.preload);
